/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { ClosedEnum } from "../../types/enums.js";

export const PaymentLinkType = {
  Payment: "payment",
  Payout: "payout",
} as const;
export type PaymentLinkType = ClosedEnum<typeof PaymentLinkType>;

/** @internal */
export const PaymentLinkType$inboundSchema: z.ZodNativeEnum<
  typeof PaymentLinkType
> = z.nativeEnum(PaymentLinkType);
/** @internal */
export const PaymentLinkType$outboundSchema: z.ZodNativeEnum<
  typeof PaymentLinkType
> = PaymentLinkType$inboundSchema;
